export function getClientePrimeiroNome(nome: string | null | undefined): string | null {
  if (!nome?.trim()) return null;
  return nome.trim().split(/\s+/)[0] ?? null;
}

export function saudacaoCliente(nome: string | null | undefined): string {
  const primeiro = getClientePrimeiroNome(nome);
  return primeiro ? `Olá, ${primeiro}` : 'Olá!';
}
